module.exports = __webpack_public_path__ + "media/img/clients/client3-a5048b0749d9b720055d7efbf3c11ddc.svg";